import BuyerGuidelines from './BuyerGuidelines';

export default BuyerGuidelines;
